module.exports = __webpack_public_path__ + "static/img/exploit3.f74a8f00.png";